import { InsuranceDto } from "../dto/insurance-dto";
import { InsuranceEntity } from "../insurance.entity";
export class InsuranceAdapater {

    public convertDtoToEntity(details: InsuranceDto): InsuranceEntity {
        const insurance = new InsuranceEntity();
        if(details.insurancefileId){
            insurance.insurancefileId = details.insurancefileId;
        }
        insurance.filePath = details.filePath;
        insurance.fileName = details.fileName;
        insurance.originalname=details.originalname;
        insurance.destination=details.destination;
        insurance.saleOrderId=details.saleOrderId;
        return insurance;
    }
    
}